import details from './details';

export const secondCoowner = {
  ...details,
};
